import React from 'react';
import Head from 'next/head';

const HeadContent = ({
  title,
  description,
  image,
}: {
  title: string;
  description: string;
  image: string;
}) => (
  <Head>
    <title>{title}</title>

    <meta name="robots" content="noindex, nofollow, noarchive, noimageindex" />

    <meta property="og:title" content={title} />

    <meta name="description" content={description} />
    <meta property="og:description" content={description} />

    <meta property="og:image:url" content={image} />
    <meta property="og:image:secure_url" content={image} />
    <meta property="twitter:image" content={image} />

    <link
      rel="preload"
      href="https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Book.woff2"
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href="https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Bold.woff2"
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
    <link
      rel="preload"
      href="https://encore.scdn.co/1.2.3/CircularSpotify-UI-Latin-OS2v3-Black.woff2"
      as="font"
      type="font/woff2"
      crossOrigin="anonymous"
    />
  </Head>
);

export default HeadContent;
